import Methods from "../methods";

const getMateriales = (context, payload) => {
  const url = `recojo/materiales/${payload.idClient}/${payload.idAddress}`;
  return Methods.doGet(context, url, null);
};

const saveItemMaterial = (context, payload) => {
  const url = `recojo/materiales/${payload.idClient}/${payload.idAddress}`;
  return Methods.doPost(context, url, payload.pickup);
};


const getMaterialesGenerados = (context, payload) => {
  const url = `recojo/materialesgenerados/${payload.idClient}/${payload.idAddress}`;
  return Methods.doGet(context, url, null);
};

const getCancelarRecojo = (context, payload) => {
  const url = `recojo/cancelarrecojo/${payload.idPickup}`;
  return Methods.doGet(context, url, null);
};


export default {
  getMateriales,
  saveItemMaterial,
  getMaterialesGenerados,
  getCancelarRecojo

};



// WEBPACK FOOTER //
// ./src/api/modules/RecojoMateriales.js